import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'kh-fixed-size-carousel-dot',
  templateUrl: './fixed-size-carousel-dot.component.html',
  styleUrls: ['./fixed-size-carousel-dot.component.less'],
  standalone: false
})
export class FixedSizeCarouselDotComponent implements OnInit {
  @Input() public index!: number;
  @Input() public activeIndex!: Observable<number>;
  @Input() public dotDiameter!: number;
  @Input() public dotActiveColour!: string;
  @Input() public dotInactiveColour!: string;

  public isActive$!: Observable<boolean>;

  public ngOnInit(): void {
    this.isActive$ = this.activeIndex.pipe(map((activeIndex) => this.index === activeIndex));
  }
}
